class ChatFeedbackModalService {
  constructor(csrfToken) {
    this.csrfToken = csrfToken;
    this.initializeElements();
  }

  initializeElements() {
    this.translatorModalEl = $('#js-chat-feedback-modal');
  }

  openModal() {
    let chatId = this.translatorModalEl.data('chatId');

    this.fetchUserMessagesCount(chatId);
  }

  fetchUserMessagesCount(chatId) {
    $.ajax({
      url: `/account/chats/${chatId}/user_messages_count`,
      method: 'GET',
      success: (data) => {
        let userMessagesCount = data.user_messages_count;

        this.updateModalContent(userMessagesCount, chatId);

        this.translatorModalEl.modal('show');
      }
    });
  }

  updateModalContent(userMessagesCount, chatId) {
    let feedbackMessage = '';
    let feedbackReportButton = '';
    let transcriptButton = '';
    let chatPoints = userMessagesCount * 2;
    // LAN-762: guided lessons and grammar drills have no feedback report. The
    // transcript and the points message still apply, so only the report button
    // goes - and the message stops promising feedback the chat can't produce.
    //
    // jQuery's .data() normally coerces the view's "false" string to a boolean,
    // but both forms are rejected here on purpose: relying on that coercion
    // alone fails OPEN (an uncoerced "false" is truthy, so the button would
    // come back for exactly the chats this is meant to hide). undefined - an
    // older page without the attribute - still means available.
    let rawFeedbackAvailable = this.translatorModalEl.data('feedbackAvailable');
    let feedbackAvailable = rawFeedbackAvailable !== false && rawFeedbackAvailable !== 'false';

    // Checked before the length split, not inside it: the short-chat copy below
    // promises a feedback report "after you've replied at least 6 times", which
    // these chats never get. The transcript still follows the usual threshold.
    if (!feedbackAvailable) {
      feedbackMessage = `<div class="text-center p-2 pb-4" id="feedback-modal-message">
                            <span style="font-size: 1rem">${I18n.t('javascript.chat.points_without_feedback', { points: chatPoints })}</span>
                         </div>`;
      transcriptButton = userMessagesCount > 5
        ? `<div class="mb-3" id="get-transcript-button"><a href="/account/chats/${chatId}/transcript.pdf" class="btn btn-get-chat-transcript btn-block" target="_blank">${I18n.t('javascript.chat.download_transcript')}</a></div>`
        : '<div class="mb-3" id="get-transcript-button"></div>';
      feedbackReportButton = '<div class="mb-3" id="get-feedback-button"></div>';
    } else if (userMessagesCount > 5) {
      feedbackMessage = `<div class="text-center p-2 pb-4" id="feedback-modal-message">
                            <span style="font-size: 1rem">${I18n.t('javascript.chat.feedback_points_with_options', { points: chatPoints })}</span>
                         </div>`;
      transcriptButton = `<div class="mb-3" id="get-transcript-button"><a href="/account/chats/${chatId}/transcript.pdf" class="btn btn-get-chat-transcript btn-block" target="_blank">${I18n.t('javascript.chat.download_transcript')}</a></div>`;
      feedbackReportButton = `<div class="mb-3" id="get-feedback-button"><a href="/account/chats/${chatId}/feedback" class="btn btn-get-chat-feedback btn-block">${I18n.t('javascript.chat.get_feedback_report')}</a></div>`;
    } else {
      feedbackMessage = `<div class="text-center p-2 pb-4" id="feedback-modal-message">
                            <span style="font-size: 1rem">${I18n.t('javascript.chat.feedback_points_without_options', { points: chatPoints })}</span>
                         </div>`;
      transcriptButton = '<div class="mb-3" id="get-transcript-button"></div>'
      feedbackReportButton = '<div class="mb-3" id="get-feedback-button"></div>'
    }

    $('#feedback-modal-message').replaceWith(feedbackMessage);
    $('#get-transcript-button').replaceWith(transcriptButton);
    $('#get-feedback-button').replaceWith(feedbackReportButton);
  }
}

export default ChatFeedbackModalService;
